var _g, _rect, _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2, _circle3, _rect2, _rect3, _rect4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 225,
    height: 207,
    viewBox: "0 0 225 207",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_5047_5201)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 112,
    cy: 169.397,
    rx: 93.7155,
    ry: 19.4733,
    fill: "#B4D3FF",
    fillOpacity: 0.31
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 58.1777,
    y: 31.8445,
    width: 99.5778,
    height: 124.156,
    rx: 2,
    fill: "white",
    stroke: "#1570EF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8001 140.444L17.2226 144.289L21.0668 145.711L17.2226 147.134L15.8001 150.978L14.3776 147.134L10.5334 145.711L14.3776 144.289L15.8001 140.444Z",
    fill: "#1570EF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.378 143.956L199.8 147.8L203.644 149.222L199.8 150.645L198.378 154.489L196.955 150.645L193.111 149.222L196.955 147.8L198.378 143.956Z",
    fill: "#1570EF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M193.111 0L194.534 3.84419L198.378 5.26667L194.534 6.68915L193.111 10.5333L191.689 6.68915L187.844 5.26667L191.689 3.84419L193.111 0Z",
    fill: "#1570EF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5999 10.5333L33.0224 14.3775L36.8666 15.8L33.0224 17.2225L31.5999 21.0667L30.1774 17.2225L26.3333 15.8L30.1774 14.3775L31.5999 10.5333Z",
    fill: "#1570EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.6111 130.789H89.5333L96.5555 114.111L104.456 135.178L112.356 103.578L120.256 129.911H128.156",
    stroke: "#1570EF",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M188.207 51.704C186.563 50.0594 184.612 48.7547 182.463 47.8646C180.315 46.9745 178.013 46.5163 175.687 46.5163C173.362 46.5163 171.059 46.9745 168.911 47.8646C166.763 48.7547 164.811 50.0594 163.167 51.704L159.756 55.1157L156.344 51.704C153.023 48.3835 148.52 46.5181 143.824 46.5181C139.128 46.5181 134.624 48.3835 131.304 51.704C127.983 55.0246 126.118 59.5281 126.118 64.2241C126.118 68.92 127.983 73.4236 131.304 76.7441L134.716 80.1557L159.756 105.196L184.796 80.1557L188.207 76.7441C189.852 75.1002 191.157 73.1484 192.047 71.0002C192.937 68.852 193.395 66.5494 193.395 64.2241C193.395 61.8987 192.937 59.5962 192.047 57.4479C191.157 55.2997 189.852 53.3479 188.207 51.704Z",
    fill: "#73ADFF",
    stroke: "#1570EF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130.789,
    cy: 129.033,
    r: 3.38889,
    stroke: "#1570EF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 215.933,
    cy: 103.578,
    r: 7.77778,
    stroke: "#FF7777",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.77778,
    cy: 80.7556,
    r: 7.77778,
    stroke: "#FF7777",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 73.7334,
    y: 56.1778,
    width: 45.6444,
    height: 5.26667,
    fill: "#73ADFF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 73.7334,
    y: 69.1778,
    width: 45.6444,
    height: 5.26667,
    fill: "#73ADFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 73.7334,
    y: 82.5111,
    width: 57.9333,
    height: 5.26667,
    fill: "#73ADFF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_5047_5201",
    x: 0.184668,
    y: 131.824,
    width: 223.631,
    height: 75.1467,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9.05,
    result: "effect1_foregroundBlur_5047_5201"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerified);
export default __webpack_public_path__ + "static/media/verified.e5c399eb23a50e5d391302a1c7f7fb3b.svg";
export { ForwardRef as ReactComponent };